// extracted by mini-css-extract-plugin
module.exports = {"busy":"BusySpinner_busy_3YJGo","spinner":"BusySpinner_spinner_ljUIX"};